var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{class:{ 'table-danger': _vm.content !== null && _vm.content.deleted_at !== null }},[_c('router-link',{attrs:{"to":_vm.link}},[_c('img',{staticClass:"rounded-circle mr-2 link",attrs:{"height":"45","width":"45","src":_vm.src}}),_vm._v("\n    "+_vm._s(_vm.content.name)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }